/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const RowIndex = (cellContent, row, rowIndex, { paginationOptions, queryParams }) => {
  let index = (queryParams.sortOrder === "asc")
    ?
    (rowIndex + (paginationOptions.page - 1) * paginationOptions.sizePerPage + 1)
    :
    (paginationOptions.totalSize - (rowIndex + (paginationOptions.page - 1) * paginationOptions.sizePerPage))

  return (
    <>
      {/* {rowIndex + (paginationOptions.totalSize - 1) * paginationOptions.sizePerPage + 1} */}
      {/* {(queryParams.sortOrder === "asc") ? (rowIndex + (paginationOptions.page - 1) * paginationOptions.sizePerPage + 1) : (paginationOptions.totalSize - (rowIndex))} */}
      {/* {
        (queryParams.sortOrder === "asc")
          ?
          (rowIndex + (paginationOptions.page - 1) * paginationOptions.sizePerPage + 1)
          :
          (paginationOptions.totalSize - (rowIndex + (paginationOptions.page - 1) * paginationOptions.sizePerPage))
      } */}
      {(index > 0 && index <= paginationOptions.totalSize) ? index : ''}
    </>
  );
}